export default __webpack_public_path__ + "static/media/trashWhite.fb6ca810.svg";